import { forwardRef } from "react";
import { classNames } from "zeta-dom-react";

export interface TagProps {
    className?: string;
    color: 'default' | 'red' | 'orange' | 'yellow' | 'green' | 'blue' | 'grey' | 'magenta';
    label: string;
}

export const Tag = forwardRef<HTMLDivElement, TagProps>((props, ref) => {
    return (
        <div ref={ref} className={classNames('eac-item-tag', { color: props.color }, props.className)}>
            <span className="eac-icon-text">{props.label}</span>
        </div>
    )
});
